/* ==========================================================================
   Oma Nimitarra theme JavaScript (vanilla, no build step)
   Modules: helpers, header, mobile nav, search, cart, carousel, reveal,
            live name preview (hero), accordions
   window.NL is defined in snippets/js-globals.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var NL = window.NL || { routes: {}, strings: {}, currency: 'EUR', locale: 'fi', shipping: {} };

  /* ---------- Helpers ------------------------------------------------------ */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }
  function money(cents) {
    try {
      return new Intl.NumberFormat(NL.locale || 'fi', { style: 'currency', currency: NL.currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + (NL.currency || '');
    }
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function lockScroll(lock) { document.body.classList.toggle('is-locked', !!lock); }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var toastTimer;
  function toast(message) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  // Very small focus trap for dialogs.
  function focusTrap(container) {
    var handler = function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    return {
      on: function () { document.addEventListener('keydown', handler); },
      off: function () { document.removeEventListener('keydown', handler); }
    };
  }

  window.NLUtil = { $: $, $$: $$, debounce: debounce, money: money, toast: toast, escapeHtml: escapeHtml };

  /* ---------- Header --------------------------------------------------------- */

  var Header = {
    init: function () {
      var header = $('[data-site-header]');
      if (!header) return;

      var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 6); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      // Dropdown menus on touch devices: first tap opens, second tap follows the link.
      var touch = window.matchMedia('(hover: none)');
      $$('[data-nav-parent]', header).forEach(function (link) {
        link.addEventListener('click', function (e) {
          if (!touch.matches) return;
          var item = link.closest('.site-nav__item');
          if (!item.classList.contains('is-open')) {
            e.preventDefault();
            $$('.site-nav__item.is-open', header).forEach(function (o) { o.classList.remove('is-open'); });
            item.classList.add('is-open');
            link.setAttribute('aria-expanded', 'true');
          }
        });
      });
      document.addEventListener('click', function (e) {
        if (e.target.closest('.site-nav__item')) return;
        $$('.site-nav__item.is-open').forEach(function (o) {
          o.classList.remove('is-open');
          var l = $('[data-nav-parent]', o);
          if (l) l.setAttribute('aria-expanded', 'false');
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') $$('.site-nav__item.is-open').forEach(function (o) { o.classList.remove('is-open'); });
      });

      // Mobile navigation
      var nav = $('[data-mobile-nav]', header);
      var toggle = $('[data-nav-toggle]', header);
      if (nav && toggle) {
        var trap = focusTrap(nav);
        var open = function () {
          nav.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
          lockScroll(true);
          trap.on();
          var c = $('[data-nav-close]', nav.querySelector('.mobile-nav__head'));
          if (c) c.focus();
        };
        var close = function () {
          nav.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
          lockScroll(false);
          trap.off();
          toggle.focus();
        };
        toggle.addEventListener('click', open);
        $$('[data-nav-close]', nav).forEach(function (b) { b.addEventListener('click', close); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !nav.hidden) close(); });
        window.addEventListener('resize', debounce(function () { if (window.innerWidth > 1199 && !nav.hidden) close(); }, 150)); // the same width as the menu button's media query in chrome.css
      }
    }
  };

  /* ---------- Announcement bar: a row of messages while it fits, otherwise a rotator ---- */

  var Announcement = {
    init: function () {
      var bar = $('[data-announcement]');
      if (!bar) return;
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      var list = $('.announcement__list', bar);
      var fit = function () {
        bar.classList.remove('is-rotating');
        if (window.innerWidth <= 989 || list.scrollWidth > list.clientWidth + 1) bar.classList.add('is-rotating');
      };
      fit();
      window.addEventListener('resize', debounce(fit, 150));
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
      var i = 0;
      setInterval(function () {
        if (!bar.classList.contains('is-rotating')) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4200);
    }
  };

  /* ---------- Search ---------------------------------------------------------- */

  var Search = {
    init: function () {
      var overlay = $('[data-search-overlay]');
      if (!overlay) return;
      var input = $('[data-search-input]', overlay);
      var results = $('[data-search-results]', overlay);
      var trap = focusTrap(overlay);
      var lastFocus;

      var open = function (e) {
        if (e) e.preventDefault();
        lastFocus = document.activeElement;
        overlay.hidden = false;
        lockScroll(true);
        trap.on();
        setTimeout(function () { input.focus(); }, 30);
      };
      var close = function () {
        overlay.hidden = true;
        lockScroll(false);
        trap.off();
        if (lastFocus) lastFocus.focus();
      };
      $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', open); });
      $$('[data-search-close]', overlay).forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });

      var run = debounce(function () {
        var q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        var url = NL.routes.searchSuggest + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = (data.resources && data.resources.results) || {};
            var rows = [];
            (res.products || []).forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + escapeHtml(p.featured_image.url) + '" alt="" loading="lazy" width="56" height="56">' : '';
              var price = p.price ? money(Math.round(parseFloat(p.price) * 100)) : '';
              rows.push('<li><a class="search-result" href="' + escapeHtml(p.url) + '"><span class="search-result__media">' + img + '</span><span><span class="search-result__title">' + escapeHtml(p.title) + '</span><br><span class="search-result__meta">' + price + '</span></span></a></li>');
            });
            (res.collections || []).forEach(function (c) {
              rows.push('<li><a class="search-result" href="' + escapeHtml(c.url) + '"><span class="search-result__media"></span><span><span class="search-result__title">' + escapeHtml(c.title) + '</span></span></a></li>');
            });
            (res.pages || []).forEach(function (c) {
              rows.push('<li><a class="search-result" href="' + escapeHtml(c.url) + '"><span class="search-result__media"></span><span><span class="search-result__title">' + escapeHtml(c.title) + '</span></span></a></li>');
            });
            if (!rows.length) {
              results.innerHTML = '<p class="search-results__empty">' + escapeHtml(NL.strings.searchNoResults || '') + '</p>';
              return;
            }
            results.innerHTML = '<ul class="search-results__list">' + rows.join('') + '</ul>' +
              '<a class="search-results__more" href="' + NL.routes.search + '?q=' + encodeURIComponent(q) + '">' + escapeHtml(NL.strings.searchAll || '') + ' &rarr;</a>';
          })
          .catch(function () { results.innerHTML = ''; });
      }, 220);
      input.addEventListener('input', run);
    }
  };

  /* ---------- Cart ------------------------------------------------------------- */

  var Cart = {
    el: null,
    inner: null,
    trap: null,
    lastFocus: null,

    init: function () {
      var self = this;
      this.el = $('[data-cart-drawer]');
      if (this.el) {
        this.inner = $('[data-cart-inner]', this.el);
        this.trap = focusTrap(this.el);
      }

      document.addEventListener('click', function (e) {
        var openBtn = e.target.closest('[data-cart-open]');
        if (openBtn && self.el && NL.cartType === 'drawer' && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
          e.preventDefault();
          self.open();
          return;
        }
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); self.close(); return; }

        var rm = e.target.closest('[data-cart-remove]');
        if (rm) { e.preventDefault(); self.change(rm.getAttribute('data-line'), 0, rm.closest('[data-cart-item]')); return; }

        var minus = e.target.closest('[data-qty-minus]');
        var plus = e.target.closest('[data-qty-plus]');
        if (minus || plus) {
          var wrap = (minus || plus).closest('[data-qty]');
          var input = $('[data-qty-input]', wrap);
          var min = parseInt(input.getAttribute('min') || '0', 10);
          var v = parseInt(input.value || '0', 10) + (plus ? 1 : -1);
          v = Math.max(min, v);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      document.addEventListener('change', function (e) {
        var input = e.target.closest('[data-cart-item] [data-qty-input]');
        if (input) {
          var q = Math.max(0, parseInt(input.value || '0', 10));
          self.change(input.getAttribute('data-line'), q, input.closest('[data-cart-item]'));
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el && self.el.classList.contains('is-open')) self.close();
      });

      document.addEventListener('cart:add', function () { self.refresh().then(function () { self.open(); self.bump(); }); });
    },

    open: function () {
      if (!this.el) return;
      this.lastFocus = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      this.trap.on();
      var panel = $('.cart-drawer__panel', this.el);
      if (panel) setTimeout(function () { panel.focus(); }, 60);
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      this.trap.off();
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },

    setCount: function (n) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.classList.toggle('is-empty', n === 0);
      });
    },

    bump: function () {
      $$('[data-cart-count]').forEach(function (el) {
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      });
    },

    // Re-render the drawer through the Section Rendering API and refresh the count.
    refresh: function () {
      var self = this;
      var jobs = [fetch(NL.routes.cartJson, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })];
      if (this.inner) {
        jobs.push(fetch(NL.routes.root + '?sections=cart-drawer').then(function (r) { return r.json(); }));
      }
      return Promise.all(jobs).then(function (res) {
        var cart = res[0];
        if (res[1] && res[1]['cart-drawer']) {
          var doc = new DOMParser().parseFromString(res[1]['cart-drawer'], 'text/html');
          var fresh = $('[data-cart-inner]', doc);
          if (fresh && self.inner) self.inner.innerHTML = fresh.innerHTML;
          if (window.OmaSticker) window.OmaSticker.hydrate(self.el);
        }
        self.setCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      });
    },

    change: function (line, quantity, itemEl) {
      var self = this;
      if (itemEl) itemEl.classList.add('is-updating');
      return fetch(NL.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return self.refresh(); })
        .then(function () { return self.refreshPage(); })
        .catch(function () { toast(NL.strings.error); if (itemEl) itemEl.classList.remove('is-updating'); });
    },

    // On the cart page, swap in the fresh server-rendered region.
    refreshPage: function () {
      var region = $('[data-cart-page]');
      if (!region) return Promise.resolve();
      return fetch(window.location.pathname + window.location.search, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-cart-page]', doc);
          if (fresh) {
            region.innerHTML = fresh.innerHTML;
            if (window.OmaSticker) window.OmaSticker.hydrate(region);
          }
        });
    },

    add: function (formData) {
      return fetch(NL.routes.cartAdd, { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || data.status) {
              throw new Error(data.description || data.message || NL.strings.error);
            }
            return data;
          });
        });
    }
  };

  window.NLCart = Cart;

  // A little sticker flies from the preview into the cart icon.
  window.NLFlyToCart = function (sourceEl) {
    if (reduceMotion || !sourceEl || !sourceEl.animate) return Promise.resolve();
    var target = $$('.cart-link').filter(function (el) { return el.offsetParent !== null; })[0];
    if (!target) return Promise.resolve();
    var a = sourceEl.getBoundingClientRect();
    var b = target.getBoundingClientRect();
    var clone = document.createElement('div');
    clone.style.cssText = 'position:fixed;z-index:400;pointer-events:none;left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;';
    clone.innerHTML = sourceEl.innerHTML;
    document.body.appendChild(clone);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2);
    var dy = b.top + b.height / 2 - (a.top + a.height / 2);
    var anim = clone.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
      { transform: 'translate(' + dx * 0.35 + 'px,' + (dy * 0.35 - 90) + 'px) scale(0.7) rotate(-14deg)', opacity: 1, offset: 0.45 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.12) rotate(28deg)', opacity: 0.4, offset: 1 }
    ], { duration: 760, easing: 'cubic-bezier(0.5, 0, 0.2, 1)' });
    return anim.finished.then(function () { clone.remove(); }, function () { clone.remove(); });
  };

  /* ---------- Carousel ----------------------------------------------------------- */

  var Carousel = {
    init: function (root) {
      $$('[data-carousel]', root).forEach(function (c) {
        if (c.dataset.ready) return;
        c.dataset.ready = '1';
        var track = $('[data-carousel-track]', c);
        var prev = $('[data-carousel-prev]', c);
        var next = $('[data-carousel-next]', c);
        if (!track) return;
        var update = function () {
          var max = track.scrollWidth - track.clientWidth - 2;
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max;
          c.classList.toggle('is-static', max <= 0);
        };
        var step = function (dir) {
          var first = track.firstElementChild;
          var w = first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
          track.scrollBy({ left: dir * w * (window.innerWidth > 989 ? 1 : 1), behavior: reduceMotion ? 'auto' : 'smooth' });
        };
        if (prev) prev.addEventListener('click', function () { step(-1); });
        if (next) next.addEventListener('click', function () { step(1); });
        track.addEventListener('scroll', debounce(update, 60), { passive: true });
        window.addEventListener('resize', debounce(update, 150));
        update();
      });
    }
  };

  /* ---------- Reveal on scroll ---------------------------------------------------- */

  var Reveal = {
    io: null,
    init: function (root) {
      if (!document.documentElement.classList.contains('nl-motion')) return;
      var els = $$('[data-reveal]:not(.is-in)', root);
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
      if (!this.io) {
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('is-in'); Reveal.io.unobserve(en.target); }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      }
      $$('[data-reveal-stagger]', root).forEach(function (parent) {
        $$('[data-reveal]', parent).forEach(function (child, i) { child.style.setProperty('--reveal-delay', (i * 0.08) + 's'); });
      });
      els.forEach(function (e) { Reveal.io.observe(e); });
    }
  };

  /* ---------- Live name preview (home hero and similar) ----------------------------- */
  // Markup contract:
  //   [data-live-name data-default-name="Aino" data-default-design="hai"]
  //     input[data-live-input]              the visitor's name
  //     [data-live-design="hai"]            design chips (get the colour and the art of the design)
  //     [data-live-sticker='{"shape":"round"}']   rendered as a sticker (JSON = render options; "sample" = its own name until the visitor types one, "fixedText" = always this text)
  //     [data-live-sheet='{"shape":"round"}']     rendered as a sheet
  //     [data-live-scene='{"scene":"clothes","shape":"oblong"}']   the sticker on an everyday scene (mockups.js)
  //     a[data-live-link]                   href gets ?name=..&design=.. appended
  //   A blob with "fixed": true keeps its own design; the others follow the chosen one.
  //   A fixed blob can have "alt": another design that it swaps to when the chosen design is the same as its own (no two unicorns side by side).
  //   assets/fx.js can give single blobs their own name, design and second line through el.nlLive.show(name, design, { selector: options }).

  var Live = {
    init: function (root) {
      $$('[data-live-name]', root).forEach(function (el) {
        if (el.dataset.ready) return;
        el.dataset.ready = '1';
        var S = window.OmaSticker;
        if (!S) return;
        var input = $('[data-live-input]', el);
        var state = {
          name: (input && input.value.trim()) || '',
          design: el.getAttribute('data-default-design') || '',
          color: el.getAttribute('data-default-color') || 'jaa'
        };
        var fallback = el.getAttribute('data-default-name') || 'Aino';

        var fontIds = [];
        $$('[data-live-sticker], [data-live-sheet], [data-live-scene]', el).forEach(function (t) {
          try {
            var f = JSON.parse(t.getAttribute('data-live-sticker') || t.getAttribute('data-live-sheet') || t.getAttribute('data-live-scene')).font;
            if (f && fontIds.indexOf(f) < 0) fontIds.push(f);
          } catch (e) {}
        });
        if (!fontIds.length) fontIds = ['blocky'];

        var follow = function (o) {
          if (o.fixed || o.fixedColor) return;
          if (state.design) { o.design = state.design; delete o.color; delete o.textColor; delete o.art; delete o.icon; }
          else { o.color = state.color; o.textColor = S.bestText(state.color); }
        };

        var render = function () {
          var text = state.name || fallback;
          var needed = text;
          $$('[data-live-sticker]', el).forEach(function (t) { if (t.nlOverride && t.nlOverride.text) needed += ' ' + t.nlOverride.text; });
          S.ready(needed, fontIds).then(function () {
            $$('[data-live-sticker]', el).forEach(function (t) {
              var o = {};
              try { o = JSON.parse(t.getAttribute('data-live-sticker')); } catch (e) {}
              o.text = o.fixedText || (state.name ? text : (o.sample || text));
              follow(o);
              if (o.fixed && o.alt && o.design && o.design === state.design) o.design = o.alt;
              if (t.nlOverride) { for (var k in t.nlOverride) o[k] = t.nlOverride[k]; }
              t.innerHTML = S.render(o).svg;
            });
            $$('[data-live-sheet]', el).forEach(function (t) {
              var o = {};
              try { o = JSON.parse(t.getAttribute('data-live-sheet')); } catch (e) {}
              o.text = text;
              follow(o);
              t.innerHTML = S.sheet(o);
            });
            // An everyday scene (t-shirt, lunch box, pencils, the squirrels) with the sticker on it: OmaSticker.mockup, see mockups.js
            $$('[data-live-scene]', el).forEach(function (t) {
              var o = {};
              try { o = JSON.parse(t.getAttribute('data-live-scene')); } catch (e) {}
              o.text = o.fixedText || (state.name ? text : (o.sample || text));
              follow(o);
              o.preview = true;
              var list;
              if (o.scene === 'perhe' || o.scene === 'pulla') {
                // the squirrels show every kind of label: round on the backpack, oblong on the cane, square on the lunch box, mini on the helmet
                list = (o.scene === 'pulla' ? ['oblong'] : ['round', 'oblong', 'square', 'mini']).map(function (shape) {
                  var oo = {};
                  for (var key in o) oo[key] = o[key];
                  oo.shape = shape;
                  var spec = S.data.SHAPES[shape];
                  return { svg: S.render(oo).svg, w: spec.w, h: spec.h, shape: shape };
                });
              } else {
                var sp = S.data.SHAPES[o.shape] || S.data.SHAPES.oblong;
                list = [{ svg: S.render(o).svg, w: sp.w, h: sp.h, shape: o.shape }];
              }
              if (!S.mockup) { t.innerHTML = ''; return; }
              if (S.mockupInto) S.mockupInto(t, o.scene, list, { shirt: o.shirt, shirt2: o.shirt2, collar: o.collar, ground: o.ground, bubble: o.bubble });
              else t.innerHTML = S.mockup(o.scene, list, { shirt: o.shirt, shirt2: o.shirt2, collar: o.collar, ground: o.ground, bubble: o.bubble });
            });
          });
          $$('[data-live-link]', el).forEach(function (a) {
            var base = a.getAttribute('data-base') || a.getAttribute('href');
            a.setAttribute('data-base', base);
            var sep = base.indexOf('?') > -1 ? '&' : '?';
            var q = [];
            if (state.name) q.push('name=' + encodeURIComponent(state.name));
            q.push(state.design ? 'design=' + encodeURIComponent(state.design) : 'color=' + encodeURIComponent(state.color));
            a.setAttribute('href', base + sep + q.join('&'));
          });
        };

        if (input) input.addEventListener('input', debounce(function () { state.name = input.value.trim(); render(); }, 140));

        // Design chips: coloured like the design, with its art in the middle
        $$('[data-live-design]', el).forEach(function (b) {
          var d = S.designById(b.getAttribute('data-live-design'));
          if (d) {
            b.style.setProperty('--swatch', d.bg);
            var art = d.a && S.art[d.a];
            if (art) b.innerHTML = '<svg viewBox="' + art[0] + '" aria-hidden="true">' + art[1] + '</svg>';
            else b.innerHTML = '<span class="swatch__aa" style="color:' + d.fg + '" aria-hidden="true">Aa</span>'; // colour and pattern designs: show the text colour
          }
          b.addEventListener('click', function () {
            state.design = b.getAttribute('data-live-design');
            $$('[data-live-design]', el).forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
            render();
          });
        });
        $$('[data-live-color]', el).forEach(function (b) {
          b.addEventListener('click', function () {
            state.color = b.getAttribute('data-live-color');
            state.design = '';
            $$('[data-live-color]', el).forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
            render();
          });
        });
        var form = $('form', el);
        if (form) {
          form.addEventListener('submit', function () {
            var hd = $('[name="design"]', form), hc = $('[name="color"]', form);
            if (hd) hd.value = state.design;
            if (hc) hc.value = state.color;
          });
        }
        render();

        // Hook for assets/fx.js (the hero demo): shows another name and design without touching the visitor's own input
        var syncPressed = function () {
          $$('[data-live-design]', el).forEach(function (o) { o.setAttribute('aria-pressed', o.getAttribute('data-live-design') === state.design ? 'true' : 'false'); });
        };
        var setOverrides = function (per) {
          $$('[data-live-sticker]', el).forEach(function (t) { t.nlOverride = null; });
          if (!per) return;
          Object.keys(per).forEach(function (sel) { $$(sel, el).forEach(function (t) { t.nlOverride = per[sel]; }); });
        };
        el.nlLive = {
          input: input,
          // name and design for the main stickers and the sheet; per = { '.selector': { text, design, text2 } } for single stickers
          show: function (name, design, per) {
            state.name = name || '';
            if (design) { state.design = design; syncPressed(); }
            setOverrides(per);
            render();
          },
          // Back to the plain example (the sample names of the markup), keeping the design that is chosen, or the visitor's own name if there is one
          reset: function () {
            state.name = input ? input.value.trim() : '';
            setOverrides(null);
            render();
          }
        };
      });
    }
  };

  /* ---------- Exclusive accordions ---------------------------------------------------- */

  var Accordion = {
    init: function (root) {
      $$('[data-accordion-group]', root).forEach(function (g) {
        if (g.dataset.ready) return;
        g.dataset.ready = '1';
        $$('details', g).forEach(function (d) {
          d.addEventListener('toggle', function () {
            if (!d.open) return;
            $$('details', g).forEach(function (o) { if (o !== d) o.open = false; });
          });
        });
      });
    }
  };

  /* ---------- Boot -------------------------------------------------------------------------- */

  function initContent(root) {
    Carousel.init(root);
    Reveal.init(root);
    Live.init(root);
    Accordion.init(root);
    if (window.OmaSticker) window.OmaSticker.hydrate(root || document);
  }

  function boot() {
    Header.init();
    Announcement.init();
    Search.init();
    Cart.init();
    initContent(document);
    document.documentElement.classList.add('is-ready');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Shopify theme editor: re-initialise sections that were re-rendered.
  document.addEventListener('shopify:section:load', function (e) { initContent(e.target); });
})();
